<mat-card (click)="quiterMenuContectuelle()" >
    <mat-card-header class="titreFrm">
        <mat-card-title>{{nomFenetre}}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
        <div *ngIf="exist;else attente"></div>
        <ng-template #attente>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-template>
        <input id="fileToUpload" type="file" (change)="onChangeFileToUpload($event)" style="display:none;">
        <div class="btn">
            <div >
                <mat-form-field     appearance="outline"  *ngIf="fenetre == 'ressources'" >
                    <mat-label>Collaborateur</mat-label>
                    <mat-select [formControl]="toppings" name="liste_Collaborateurs" [(ngModel)]="listeSelectedCollaborateurs" multiple (selectionChange)="filterListeRessourcesByCollaborateur(true,true)">
                        <mat-option *ngFor="let collaborateur of listeCollaborateurs" [value]="collaborateur.Perso_Matricule">{{collaborateur.Perso_Nom + " " + collaborateur.Perso_Prenom}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div *ngIf="fenetre == 'ressource'" class="displayFlex">
                <div class="button-row">
                    <button (click)="ajouterDossier(frmAddFolder)" mat-raised-button class="colorGreen"> <mat-icon>create_new_folder</mat-icon>Ajouter dossier</button>
                </div>
                <div class="button-row">
                    <button (click)="ajouterFicher()" mat-raised-button class="colorGreen"> <mat-icon>insert_drive_file</mat-icon>Ajouter fichier</button>
                </div>
                <div class="button-row">
                    <button (click)="renommerFichierDossier(frmAddFolder)" mat-raised-button class="colorGreen"> <mat-icon>edit</mat-icon>Renommer</button>
                </div>
                <div  class="button-row">
                    <button (click)="telechargerFicher()" mat-raised-button class="colorGreen"><mat-icon>cloud_download</mat-icon>Télécharger</button>
                </div>
                <div class="button-row">
                    <button  (click)="supprimerFicher()" mat-raised-button class="colorGreen"><mat-icon>delete</mat-icon>Supprimer</button>
                </div>
            </div>
            
        </div>
        <table mat-table [dataSource]="listeRessources" >
            <ng-container *ngFor="let column of columns.TableRD; let i = index" matColumnDef="{{column.TableRD_Champs}}">
                <th [ngStyle]="getStyle(column)" mat-header-cell *matHeaderCellDef >
                    <table style="width: 100%" >
                      <tr >
                        <td style="width: 80%" align="{{textAlign[column.TableRD_Alligement]}}">
                          <mat-form-field     appearance="outline"  [ngStyle]="getStyle(column)" >              
                              <input [ngStyle]="getStyle(column)" [placeholder]="column.TableRD_Des" matInput [ngClass]="'inputSearch'" (keyup)="onkeyup(true,true)" [name]="column.TableRD_Champs">
                          </mat-form-field>
                        </td>
                        <td style="width: 20%"></td>
                      </tr>
                    </table>                                       
                  </th>
                <td mat-cell *matCellDef="let row;">
                    <div class="displayFlex" [ngStyle]="{'margin-left': i == 0 ? row.margin + 'px' :  0 }">
                        <div class="height100" >
                            <button *ngIf="i == 0" mat-icon-button color="primary">
                                <mat-icon (click)="toggleRow(row)" >{{row.icon }}</mat-icon>
                            </button>
                        </div>
                        <div class="cellule">
                            <span *ngIf="i==0" >{{row[column.TableRD_Champs] }}</span>
                            <div class="cellule2" *ngIf="row[column.TableRD_Champs] != 0 && i > 0">
                                <span *ngIf="column.TableRD_Type==4" >{{row[column.TableRD_Champs]  | date: column.TableRD_Format}}</span>
                                <span *ngIf="column.TableRD_Type==0" >{{row[column.TableRD_Champs] }}</span>
                            </div>
                        </div>
                        
                    </div>                        
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnsName; sticky: true"></tr>
            <tr [ngClass]="'rowClass ' + row.class"  mat-row *matRowDef="let row; columns: columnsName;" (contextmenu)="openMenuContectuelle($event,row)" (click)="clickRow($event,row)"></tr>
        </table>
        
        <mat-card >
            <mat-card-content>
                
            </mat-card-content>
        </mat-card>
    </mat-card-content>
</mat-card>
<ng-template #frmAddFolder>
    <mat-card>
        <mat-card-content>
            <mat-form-field     appearance="outline" >
                <mat-label>Nom de dossier</mat-label>
                <input matInput name="addFolder" #add_Folder="ngModel"
                [(ngModel)]="nameFolder" placeholder="Nom de dossier" required>
            </mat-form-field>
        </mat-card-content>
        <mat-card-actions>
          <button (click)="closeFrmAddFolder('annuler')" class="colorRed" mat-raised-button ><mat-icon>close</mat-icon>Fermer</button>
          <button (click)="closeFrmAddFolder('ok')" class="colorGreen" mat-raised-button ><mat-icon>keyboard_return</mat-icon>Ok</button>
    
        </mat-card-actions>
    </mat-card>
</ng-template>
<ng-template #menuContectuelle let-user>
    <section class="user-menu">
        <div (click)="ajouterDossier(frmAddFolder)" >Ajouter dossier</div>
        <div (click)="ajouterFicher()">Ajouter ficher</div>
        <div (click)="renommerFichierDossier(frmAddFolder)">Renommer</div>
        <div (click)="telechargerFicher()">Télécharger</div>
        <div (click)="supprimerFicher()">Supprimer</div>
        <div (click)="quiterMenuContectuelle()" >Quiter</div>
    </section>
</ng-template>